import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SmartTagLimit, SmartTagOrderRequest, SmartTagOrderItem, SmartTagOrderType, SmartTagSource } from 'src/app/interfaces/smart-tag';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmartTagService {

  constructor(
    private http: HttpClient,
  ) { }

  public getSmartTagLimit() {
    return this.http.get<SmartTagLimit>(`${environment.apiUrl}/api/orders/user/me/smarttag/limit`);
  }

  public orderFreeTags(tags: SmartTagOrderItem[]) {
    const body: SmartTagOrderRequest = {
      intent: SmartTagOrderType.FreeNew,
      tags,
      source: SmartTagSource.Website
    };

    return this.http.post(`${environment.apiUrl}/api/orders/smarttag`, body);
  }
}
